<template>
  <Content :button-create-show="true">
    <template #body>
      <Table
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data="methods.fetchData"
        :method-delete-row="methods.deleteRow"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Table from "@/components/Table";

import { getRatios, deleteRatio as deleteRow } from "@/api/ratios";

const columnsOptions = {
  sortable: "custom",
  controls: true,
  id: "id",
  edit: true,
  delete_row: {
    buttonName: "Удалить",
  },
};

const columns = [
  {
    prop: "id",
    label: "ID",
  },
  {
    prop: "name",
    label: "Наименование",
  },
  {
    prop: "width",
    label: "Ширина",
  },
  {
    prop: "height",
    label: "Высота",
  },
];

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      columnsOptions: columnsOptions,
      columns: columns,
      methods: {
        async fetchData(params) {
          const data = await getRatios(params);
          return data.ratios;
        },
        deleteRow,
      },
    };
  },
};
</script>
